import { Link } from 'react-router-dom';
import { persistence } from '@platform/state/persistence';
import { useAppSelector } from '@platform/state/hooks';
import { selectCurrentWorkspaceId } from '@platform/state/selectors';
import type { IWorkspaceLinkProps } from './IWorkspaceLinkProps';
import { useOpenInWorkspace } from './useOpenInWorkspace';

/**
 * Посилання на адресу в іншому робочому просторі (ADR-028): звичайний клік відкриває адресу, зробивши простір `ws` поточним у вкладці
 * (useOpenInWorkspace); клік у нову вкладку (Ctrl/⌘, Shift, середня кнопка) лишає вкладку як є, а простір стає останнім використаним — його
 * бере нова вкладка (запис, якого там немає, однаково знайде свій простір — useRecordRelocation).
 */
export function WorkspaceLink({ ws, onClick, ...link }: IWorkspaceLinkProps) {
  const current = useAppSelector(selectCurrentWorkspaceId);
  const open = useOpenInWorkspace();
  return (
    <Link {...link} onClick={(e) => {
      onClick?.(e);
      if (e.defaultPrevented || !ws || ws === current) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || link.target === '_blank') { persistence.rememberWorkspace(ws); return; }
      e.preventDefault();
      open(ws, link.to, link.replace);
    }} />
  );
}
